import styled, { css } from 'styled-components';

import { Accordion } from '@/components/Accordion';
import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

export const Text = styled(Box)`
  text-align: justify;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.h5Mobile};
  `}
`;
export const ContentWrapper = styled(Box)`
  padding: 14px 10px 0 10px;
`;
export const CtasWrapper = styled(Flex)``;
export const NoteTypography = styled(Typography)`
  color: ${theme.colors.charcoalGray};
`;
export const StyledAccordion = styled(Accordion)<{ $isOpen: boolean }>`
  &&& {
    header {
      button {
        min-height: 48px;
        height: auto;
        padding: ${theme.spacing(1.25, 2)};
        justify-content: space-between;
        p {
          font-weight: 700;
          text-align: left;
        }
        svg {
          color: ${({ $isOpen }) =>
            $isOpen ? theme.colors.goldenRod : theme.colors.primaryDark};
        }
      }
    }
  }
`;
